import * as t from 'actions/actionTypes';

import initialState from 'reducers/initialState';

export default (
  state = initialState.freeAccessToUser,
  action: t.FreeAccessToUserActionTypes
) => {
  switch (action.type) {
    case t.FREE_ACCESS_TO_USER_LOAD:
      return { ...state, isLoading: true };
    case t.FREE_ACCESS_TO_USER_SUCCESS:
      return {
        isLoading: false,
        hasError: false,
      };
    case t.FREE_ACCESS_TO_USER_ERROR:
      return { ...state, isLoading: false, hasError: true };
    case t.LOG_OUT.SUCCESS:
      return initialState.accessItems;
    default:
      return state;
  }
};
